import type { TypeOf } from 'io-ts';

import fromEnum from '@/scripts/io-ts/fromEnum';

export const NotificationType = {
    TAG: 'Tag',
    SHARING: 'Sharing',
    REPLY: 'Reply',
    UPLOAD_LINK: 'UploadLink',
    AUDIO: 'Audio',
    CONVERSION: 'Conversion',
    MULTIVIEW: 'Multiview',
    TRANSCRIPTION: 'Transcription',
} as const;

export const NotificationTypeC = fromEnum('NotificationType', NotificationType);

export type NotificationType = TypeOf<typeof NotificationTypeC>;
